import { render, staticRenderFns } from "./CountIndicator.vue?vue&type=template&id=8546e51c&scoped=true"
import script from "./CountIndicator.vue?vue&type=script&lang=js"
export * from "./CountIndicator.vue?vue&type=script&lang=js"
import style0 from "./CountIndicator.vue?vue&type=style&index=0&id=8546e51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8546e51c",
  null
  
)

export default component.exports